import styled from 'styled-components';
import { Colors } from '../../themes';

// @todo: ajustar responsividade
export const Container = styled.div`
  display: flex;
  flex: 1;
  margin: 150px 0 4% 15.625%;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 1024px) {
    margin: 150px 0 0 0;
  }

  @media (max-width: 960px) {
    margin: 100px 0 0 0;

    h1 {
      margin-left: 25px !important;
      margin-right: 25px !important;
    }
  }
`;

export const ContainerSuccess = styled(Container)`
  padding: 6rem 0;
  width: 30%;

  @media (max-width: 960px) {
    width: 100%;
    padding: 2rem 0;
  }
`;

export const TitleSuccess = styled.h1`
  font-size: 2rem;
  font-weight: 100;
  line-height: 2.5rem;
  color: ${props => props.color || Colors.text.main};

  highlight {
    border-bottom: 2px solid #ee1f99;
  }

  @media (max-width: 1024px) {
    margin: 2% 15% 0 15%;
  }

  @media (max-width: 960px) {
    margin: 2% 8% 0 8%;
  }
`;

export const ButtonContainer = styled.div`
  max-width: 515px;
  margin-top: 42px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  & + div {
    margin-top: 42px;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
  }

  @media (max-width: 960px) {
    flex-direction: column;
    margin-bottom: 10%;
  }
`;

export const Paragraph = styled.p`
  font-size: 1rem;
  font-weight: 300;
  color: #6c677a;
  text-align: right;
  margin-right: 22px;

  @media (max-width: 1024px) {
    margin-bottom: 5%;
    font-size: 2.2rem;
  }

  @media (max-width: 960px) {
    margin-bottom: 5%;
    font-size: 1.2rem;
    margin-right: 0;
    text-align: center;
  }
`;

export const SnackbarContainer = styled.div`
  margin-top: 38.5px;
`;

export const BackButton = styled.a`
  border: 2px solid #ffffff;
  background: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: .7rem 1.8rem;
  border-radius: 500px;
  color: #ffffff;
  margin-right: 1rem;
  cursor: pointer;
  text-decoration: none;

  @media (max-width: 960px) {
    margin-bottom: 8%;
  }
`;
